import { ADD_EMPTY_STRING } from "../../../enums/Request/request.types";

export const addDimmisialAdressCurrentRequest = () => {
    return {
        type: ADD_EMPTY_STRING,
        payload: "  ",
    };
};
